"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultScrapeInfo = void 0;
const defaultScrapeInfo = {
    timeStartISO: "",
    timeEndISO: "",
    timeElapsedInSeconds: -1,
    pageVersionIdentifier: "",
};
const getDefaultScrapeInfo = () => (Object.assign({}, defaultScrapeInfo));
exports.getDefaultScrapeInfo = getDefaultScrapeInfo;
//# sourceMappingURL=ScrapeInfo.js.map